module.exports = function (app) {
	var coverageInactive = require("../../../modals/covInactiveModal"),
		coverageFuture = require("../../../modals/covFutureModal"),
		coverageNoPay = require("../../../modals/covNoPayModal"),
		coverageCancelled = require("../../../modals/covCancelledModal");
    app.controller('pages.account.membership-information', ['$scope','$q','$window', 'coremetrics','sessionData',"brand", "modal", 'finder-logic2', 'services','UMSParse', '$state', 'storage',
        function ($scope, $q, $window, coremetrics, sessionData, brand, modal, finderLogic, services, UMSParse, $state, storage) {

window.$scope = $scope;
            $scope.shouldShowDOB = false;
			$scope.showPastCoverage = false;
            $scope.showFutureCov = false;
			$scope.showNoPlansMessage = false;
            $scope.masterShowDate = true;
			$scope.showIdCard = true;
			var memberData = sessionData.memberInfo;
			var policyState;
            var newData = memberData;
			var serverDate = new Date();
			var ums = new UMSParse(newData, serverDate);
			$scope.isWyoming = brand.current.sharedBrandCode.toLowerCase() == 'wybcbs';
			$scope.states = ums.getPlansForWhen();
			$scope.hasActivePlans = $scope.states.current > 0? true:false;
			$scope.hasPastPlans = $scope.states.past > 0? true:false;
			$scope.hasFuturePlans = $scope.states.future > 0? true:false;
			$scope.state = 0;




			if($scope.hasActivePlans == false ){
				policyState =  "future";
				$scope.planTimes = {value:"future"};
				$scope.state = 2;
				$scope.showIdCard = true;
				$scope.showPastCoverage = false;
				$scope.showCancel = false ;
				$scope.showFutureCov = true;
				$scope.masterShowDate = false;
			}
			if($scope.hasActivePlans == false && $scope.hasFuturePlans == false){
				policyState = "past";
				$scope.planTimes = {value:"past"};
				$scope.state = 1;
				$scope.showIdCard = true;
				$scope.showPastCoverage = true;
				$scope.showFutureCov = false;
				$scope.showCancel = false ;
				$scope.masterShowDate = true;
			}
			if ($scope.hasActivePlans== false && $scope.hasFuturePlans== false && $scope.hasPastPlans== false) {
				//     // User has no plans, show error message
				$scope.showPastCoverage = false;
				$scope.showFutureCov = false;
				$scope.showNoPlansMessage = true;
			}

			$scope.reDraw = function(n){
				var	show = null;

				if($scope.state != n){
					$scope.state = n;
					if(n== 0){
						show = 'current';
						$scope.showPastCoverage = false;
						$scope.showFutureCov = false;
						$scope.showIdCard = true;
						$scope.showCancel = true;
						$scope.masterShowDate = true;
						$scope.planTimes = {value:'current'};
						if(this.showCurrCoremetrics != true)
						{
							coremetrics.pageviewTag('MEMBER:ACCOUNT SETTINGS:MEMBERSHIP INFORMATION:ACTIVE',
															  'MEMBER:ACCOUNT SETTINGS');
							this.showCurrCoremetrics = true;
						}
					} else if(n== 1){
						$scope.showIdCard = true;
						$scope.showPastCoverage = true;
						$scope.showFutureCov = false;
						$scope.showCancel = false;
						$scope.masterShowDate = true;
						$scope.planTimes = {value:"past"};
						show = 'past';
						if(this.showPastCoremetrics != true)
						{
							coremetrics.pageviewTag('MEMBER:ACCOUNT SETTINGS:MEMBERSHIP INFORMATION:PAST',
															  'MEMBER:ACCOUNT SETTINGS');
							this.showPastCoremetrics = true;
						}
					}else if(n== 2){
						$scope.showIdCard = true;
						$scope.showPastCoverage = false;
						$scope.showFutureCov = true;
						$scope.showCancel = false;
						$scope.masterShowDate = false;
						show = 'future';
						$scope.planTimes = {value: 'future'};
						if(this.showFutureCoremetrics != true)
						{
							coremetrics.pageviewTag('MEMBER:ACCOUNT SETTINGS:MEMBERSHIP INFORMATION:FUTURE',
															  'MEMBER:ACCOUNT SETTINGS');
							this.showFutureCoremetrics = true;
						}
					}

					//if ( ! ums)
					//	ums = btsGlobal.currentPage.model.ums ;

					ums.setFilterState(show);

					var parsedresponse = ums.ASMemberInfoFeed();

					for (var x = 0; x < parsedresponse.clientList.length; x++) {
						var currentClient = parsedresponse.clientList[x];
						for (var y = 0; y < currentClient.members.length; y++) {
							var currentUser = currentClient.members[y];
							for (var z = 0; z < currentUser.cards.length; z++) {
								var currentCard = currentUser.cards[z];
								currentCard.viewCardID = {"card":currentCard.id,"cancelled":currentCard.cancelled ,"paid":parsedresponse.clientList[x].members[y].cards[z].paid, "hcrProduct":parsedresponse.clientList[x].members[y].cards[z].hcrProduct };//[x,y,z];
							}
						}
					}

					$scope.memberInformation = angular.copy(parsedresponse.clientList);
					//$scope.$apply();
				}

			};
			//$scope.changeView = function(x){
			//	//$scope.state = x;
			//	$scope.reDraw(x);
			//};
			var viewIDCardOrStatusModal = function(data, cardId) {
				var that = this;
				if(data && data.returnCodeDescription === "GROUP IN PEND STATUS") {
					//If you are here then the id card status is in pending state
					if (that.groupPendCoremetrics != true) {
						coremetrics.pageviewTag('MEMBER:ACCOUNT SETTINGS:MEMBERSHIP INFORMATION:PENDING ID CARD',
														  'MEMBER:ACCOUNT SETTINGS');
						that.groupPendCoremetrics = true;
					}
					modal.open({
								   template: '<h1>CANNOT VIEW CARD </h1>'+
								   ' <p data-sly-resource="${"MER_MBRINFO_GRPPEND" @' +' resourceType="ehs / bootstrap / components / plaintext"' + ' }"></p>'+
								   ' <p class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>',
									classes: 'sizeModalContainer'
				});
				}
				else if(data && data.returnCodeDescription === "GROUP IN READY STATUS") {
					//If you are here then the id card status is in ready state
					if(this.groupReadyCoremetrics != true)
					{
						coremetrics.pageviewTag('MEMBER:ACCOUNT SETTINGS:MEMBERSHIP INFORMATION:READY ID CARD',
														  'MEMBER:ACCOUNT SETTINGS');
						this.groupReadyCoremetrics = true;
					}
					modal.open({
						template: '<h1>CANNOT VIEW CARD </h1>'+
						' <p data-sly-resource="${"MER_MBRINFO_GRPREADY " @'+'resourceType="ehs / bootstrap / components / plaintext"' + ' }"></p>'+
					'<p class="text-r"><button data-ng-click="closeModal()" class="action-btn">OK</button></p>'
					});
				} else {
					coremetrics.elementTag('View ID Card','MEMBER:ACCOUNT SETTINGS');
					$state.go('account.viewIdCard');
					//$window.location = 'account/view-id-card?c='+cardId;
				}
				$scope.closeModal();
			};
			var validateBeforeViewIdCards = function(cardId, deferred) {
				//var self = this;
				//var serviceCalls = [services.BasicInfo.getData(this.stubs), services.MemberInfo.getData(this.stubs), services.ServerDate.getDate()];
				//all(serviceCalls).then(lang.hitch(this, function(responses) {
					services.rbsmbl.basicInfo().fetch().then(function(response1){
						var newData = sessionData.memberInfo;
						newData.loginId = response1.data.payload.basicInfo.loginId;
						var serverDate = new Date();
						var ums = new UMSParse(newData.payload, serverDate);
						var cardData = cardId.split('-');
						switch (Number(cardData[0])) {
							case 0:
								ums.setFilterState('past');
								break;
							case 1:
								ums.setFilterState('current');
								break;
							case 2:
								ums.setFilterState('future');
								break;
						}
						var c = [cardData[1], cardData[2], cardData[3]];
						var parsedresponse = ums.ASMemberInfoFeed();
						var baseInfo = ums.baseInformation();

						if (c[0] >= parsedresponse.clientList.length) {
							c = [0,0,0];
						}

						var members = parsedresponse.clientList[c[0]] && parsedresponse.clientList[c[0]].members || [];
						var currentUser = members[c[1]];
						if (currentUser && c[2] >= currentUser.cards.length) {
							c = [c[0],c[1],0];
						}
						var currentCard = currentUser.cards[c[2]];
						var getParams = "MProfileId="+
							"&UId="+response1.data.payload.basicInfo.loginId+
							"&GNumber="+currentCard.plans[0].groupNumber+
							"&UNumber="+baseInfo.umi+
							"&EciId="+(currentUser.ecId || '')+
							"&CType="+(currentCard.consolidated === "true" ? "CON" : benefitTypeToCType(currentCard.plans[0].benefitPlanType))+
							"&SID=WEB"+
							"&logoId="+baseInfo.brand+
							"&covIndId="+currentUser.ciid+
							"&timestamp="+Number(new Date());



						var idCardStatus = services.rbsmbl.idCardStatus().getIdCardStatus(getParams);
						idCardStatus.then(function(jsonObj) {
							deferred.resolve(jsonObj); //This will resolve if the response content-type is application/json
						}, function(imgObj) {
							deferred.resolve(imgObj); //This will resolve if the response content-type is image/jpeg
						});

					});

			};
			$scope.viewIDCard = function(tmpCard) {
				storage.set("idCard",tmpCard.viewCardID);
				var id = tmpCard.viewCardID;
				if ($scope.state == 1) {//1 = past
					//if (this.pastCoremetrics != true) {
					//	btsGlobal.coremetrics.pageviewTag('MEMBER:ACCOUNT SETTINGS:MEMBERSHIP INFORMATION:PAST ID CARD', 'MEMBER:ACCOUNT SETTINGS');
					//	this.pastCoremetrics = true;
					//}
					modal.open({
						templateUrl: 'account.appTemplate.html/chmhom/modals/covInactiveModal',
						classes: 'sizeModalContainer',
						controller: coverageInactive,
						scope: $scope
					});
				}
				else if ($scope.state == 2) {//2 = future
					//if (futureCoremetrics != true) {
					//	btsGlobal.coremetrics.pageviewTag('MEMBER:ACCOUNT SETTINGS:MEMBERSHIP INFORMATION:FUTURE EFFECTIVE ID CARD', 'MEMBER:ACCOUNT SETTINGS');
					//	futureCoremetrics = true;
					//}
					if ((brand.current.sharedBrandCode.toLowerCase() == "ibccr") || (brand.current.sharedBrandCode.toLowerCase() == "ibcah")) {
						var statusCheckDeferred = $q.defer();
						statusCheckDeferred.resolve(then(function(response) {
							viewIDCardOrStatusModal(response.data, id.card);
						}));
						validateBeforeViewIdCards(id.card, statusCheckDeferred);
					}
					else {
						modal.open({
						templateUrl: 'account.appTemplate.html/chmhom/modals/covFutureModal',
						controller: coverageFuture,
						scope: $scope
					});
					}
				}
				else {
					if (id.cancelled) {
						//if (this.cancelCoremetrics != true) {
						//	btsGlobal.coremetrics.pageviewTag('MEMBER:ACCOUNT SETTINGS:MEMBERSHIP INFORMATION:CANCELLED ID CARD', 'MEMBER:ACCOUNT SETTINGS');
						//	this.cancelCoremetrics = true;
						//}
						modal.open({
							templateUrl: 'account.appTemplate.html/chmhom/modals/covCancelledModal',
							controller: coverageCancelled,
							scope: $scope
						});
					}
					else if (id.hcrProduct && id.paid !== "paid") {
						//if (this.nonEffectCoremetrics!=true) {
						//	btsGlobal.coremetrics.pageviewTag('MEMBER:ACCOUNT SETTINGS:MEMBERSHIP INFORMATION:PREEFFECTUATED ID CARD', 'MEMBER:ACCOUNT SETTINGS');
						//	this.nonEffectCoremetrics = true;
						//}
						modal.open({
							templateUrl: 'account.appTemplate.html/chmhom/modals/covNoPayModal',
							controller: coverageNoPay,
							scope: $scope
						});
					}
					else if (brand.current.sharedBrandCode.toLowerCase() == "ibccr" || brand.current.sharedBrandCode.toLowerCase() == "ibcah") {
						var statusCheckDeferred = $q.defer();
						statusCheckDeferred.resolve(then(function (response) {
							viewIDCardOrStatusModal(response.data, id.card);
						}));
						validateBeforeViewIdCards(id.card, statusCheckDeferred);
					}
					else {
						//btsGlobal.coremetrics.elementTag('View ID Card','MEMBER:ACCOUNT SETTINGS');
						$state.go('account.viewIdCard');
						//$window.location = 'account/view-id-card?c='+id.card;
					}
				}
			};




			ums.setFilterState(policyState);
			var parsedresponse = ums.ASMemberInfoFeed();
			$scope.memberInformation = parsedresponse.clientList;
			var selectPlanDetails   =   ums.getPortalSelectedPlan();

			var blueExtraBasic = 'false';
			var blueExtraPlus  = 'false';

			if (selectPlanDetails && selectPlanDetails[0] && selectPlanDetails[0].productList && selectPlanDetails[0].productList[0]) {
				if (selectPlanDetails[0].productList[0].isBlueExtraBasic === 'true') {
					blueExtraBasic = 'true';
				}
				if (selectPlanDetails[0].productList[0].isBlueExtraPlus === 'true') {
					blueExtraPlus = 'true';
				}
			}

			$scope.getBenefitBeginDate = function (card) {
				var firstPlan = card.plans[0];
				var currentYear = new Date().getFullYear().toString();
				if (firstPlan.benefitAccumulationStartDate !== "" && firstPlan.benefitAccumulationStartDate !== firstPlan.coverageBeginDate) {
					if(firstPlan.effectDate.policyState === 'past' &&
						firstPlan.benefitAccumulationEndDate !== "" &&
						firstPlan.benefitAccumulationEndDate !== firstPlan.coverageEndDate &&
						(firstPlan.benefitAccumulationStartDate).length > 3 &&
						currentYear === (firstPlan.benefitAccumulationStartDate).slice(-4) &&
						(firstPlan.benefitAccumulationEndDate).length > 3 &&
						currentYear === (firstPlan.benefitAccumulationEndDate).slice(-4)){
						return '01/01/'+(currentYear-1);
					}
					return firstPlan.benefitAccumulationStartDate;
				}
				return firstPlan.coverageBeginDate;
			};

			$scope.getBenefitEndDate = function (card) {
				var firstPlan = card.plans[0];
				var currentYear = new Date().getFullYear().toString();
				if (firstPlan.benefitAccumulationEndDate !== "" && firstPlan.benefitAccumulationEndDate !== firstPlan.coverageEndDate) {
					if(firstPlan.effectDate.policyState === 'past' &&
						firstPlan.benefitAccumulationStartDate !== "" &&
						firstPlan.benefitAccumulationStartDate !== firstPlan.coverageBeginDate &&
						(firstPlan.benefitAccumulationStartDate).length > 3 &&
						currentYear === (firstPlan.benefitAccumulationStartDate).slice(-4) &&
						(firstPlan.benefitAccumulationEndDate).length > 3 &&
						currentYear === (firstPlan.benefitAccumulationEndDate).slice(-4)){
						return '12/31/'+(currentYear-1);
					}
					return firstPlan.benefitAccumulationEndDate;
				}
				return firstPlan.coverageEndDate;
			};

			$scope.getCoverageUrl = function (card) {
				var baseUrl = 'coverage/coverage-summary';
				if (baseUrl.charAt(baseUrl.length - 1) === '/') {
					baseUrl = baseUrl.slice(0, -1);
				}
				window.location= baseUrl + "?group=" + card.displayGroupNumber+ "&state="+ card.plans[0].effectDate.policyState + "&productNumber="+card.plans[0].productNumber;;
			};


			var memberId;
			var getMemberIdFromGroup = function(currentCard){
				memberData.clientList.forEach(function (client) {
					client.groupList.forEach(function (group) {
						if (currentCard.groupNumber === group.groupNumber) {
							if (!!group.clientAssignedId) {
								return memberId = group.clientAssignedId;
							} else {
								return memberId = currentCard.memberId;
							}
						}
					});

					if (memberId) {
						return memberId;
					}
				});

				return memberId;

			};

			for (var x = 0; x < parsedresponse.clientList.length; x++) {
				var currentClient = parsedresponse.clientList[x];
				for (var y = 0; y < currentClient.members.length; y++) {
					var currentUser = currentClient.members[y];

					for (var z = 0; z < currentUser.cards.length; z++) {
						var currentCard = currentUser.cards[z];
						currentCard.viewCardID = {"card":currentCard.id,"cancelled":currentCard.cancelled ,"paid":parsedresponse.clientList[x].members[y].cards[z].paid, "hcrProduct":parsedresponse.clientList[x].members[y].cards[z].hcrProduct };//[x,y,z];

						currentCard.memberId = getMemberIdFromGroup(currentCard);

						//splice the medical and pharmacy icons if it is blue extra only
						if(blueExtraBasic==='true' || blueExtraPlus==='true'){
							var iconsListLength =   currentCard.iconList.length;
							for(var iconIndex=0;iconIndex<iconsListLength;++iconIndex){
								if(currentCard.iconList[iconIndex].icon==="icon-provider" || currentCard.iconList[iconIndex].icon==="icon-pharmacy"){
									currentCard.iconList.splice(iconIndex,1);
									iconsListLength =   iconsListLength-1;
									iconIndex = 0;
								}
							}
						}
					}
				}
			}
			$scope.reDraw($scope.state);
        }
    ]);

	return[
		{
			state: "account.viewIdCard",
			postPassword: true,
			appConfigMaintenanceApp: 'ACCOUNT_SETTINGS',
			appConfigMaintenanceKey: 'VIEW_ID_CARD_MAINTENANCE',
			url: "/view-id-card",
			views: {
				abstract: true,
				'body@': {
					template: bootstrap.templates['page-templates/categoryCustom.html'],
					controller: "pages.account.view-id-card"
				}
			},
			"content@account": {
				templateUrl: 'account/view-id-card.appTemplate.html/chmhom/pages/account/view-id-card/view-id-card',
				controller: "pages.account.view-id-card"

			}
		}
	]
};